import { Component } from '@angular/core';
import { environment } from '@env/environment';

@Component({
    selector: 'gh-footer-us',
    templateUrl: 'footer-us.component.html',
    standalone: false
})

export class FooterUsComponent {
  gcsCdn = environment.cdnPath;
  footerMenu = [
    {
      label: 'Company',
      menu: [
        { page: 'https://www.acorns.com/press/', label: 'Press' },
        { page: 'https://www.acorns.com/careers/', label: 'Careers' },
        { page: 'https://www.gohenry.com/us/terms-and-conditions/', label: 'Terms & Conditions' },
        { page: 'https://www.gohenry.com/us/terms-and-conditions/privacy-policy/', label: 'Privacy Policy' },
        { page: 'https://us.support.gohenry.com/us/s/article/How-do-I-make-a-complaint ', label: 'Complaints' },
        { page: 'https://us.support.gohenry.com/us/s/', label: 'Member Support' },
        { page: 'https://cdn.gohenry.com/site-furniture/amp-us/pdfs/AE_Accessibility_Statement.pdf', label: 'Accessibility' },
        { page: 'https://app.impact.com/campaign-promo-signup/Acorns-Invest-Spare-Change.brand?execution=e1s1&#/?viewkey=signUpPreStart', label: 'Affiliates' }
      ]
    },
    {
      label: 'Resources',
      menu: [
        { page: 'https://www.gohenry.com/us/blog/online-safety', label: 'Online Safety Tips' },
        { page: 'https://www.gohenry.com/us/blog/parental-controls', label: 'Parental Controls Tips' },
        { page: 'https://www.gohenry.com/us/blog/chores', label: 'Chores Tips' },
        { page: 'https://www.gohenry.com/us/blog/allowance', label: 'Allowance Tips' },
        { page: 'https://www.gohenry.com/us/blog/money-management', label: 'Money Management Tips' },
        { page: 'https://www.gohenry.com/us/blog/financial-literacy-101', label: 'Financial Literacy 101' }
      ]
    },
    {
      label: 'Popular Pages',
      menu: [
        { page: 'https://www.gohenry.com/us/blog/allowance/how-much-allowance-should-we-give-our-kids-by-age-gohenry', label: 'How Much Allowance' },
        { page: 'https://www.gohenry.com/us/blog/financial-education/how-to-teach-kids-about-money', label: 'Teaching Kids About Money' },
        { page: 'https://www.gohenry.com/us/blog/chores/age-appropriate-chore-list-for-kids', label: 'Age Appropriate Chores' },
        { page: 'https://www.gohenry.com/us/blog/financial-education/the-best-small-business-ideas-for-kids-gohenry', label: 'Small Business Ideas for Kids' },
        { page: 'https://www.gohenry.com/us/blog/financial-education/how-old-do-you-have-to-be-to-get-a-credit-card', label: 'How Old to Get Credit Card' },
        { page: 'https://www.gohenry.com/us/blog/chores/27-chores-for-10-12-year-olds', label: 'Chores for 10 - 12 Year Olds' }
      ]
    }
  ];

  constructor() { }
}
